export const juspayStatus = {
  user_aborted: "user_aborted",
  api_failure: "api_failure",
  authorizing: "authorizing",
  backpressed: "backpressed",
  cod_initiated: "cod_initiated",
  success: "success",
  process_result: "process_result",
};

export const juspayEvents = {
  show_loader: "show_loader",
  hide_loader: "hide_loader",
  initiate_result: "initiate_result",
  process_result: "process_result",
};

export const availablePaymentMethods = {
  cod: "COD",
  juspay: "JUSPAY",
};

export const yes = "YES";

export const no = "NO";
